export default class About {
    static initial() {
        this.plugins();
    }

    static plugins() {

        //Certifications
        let $certifications = $('.certification_carousel');
        $certifications.owlCarousel({
            loop: false,
            margin: 10,
            items:1,
            dots: true,
            nav: false,
            autoWidth:true,
            responsive:{
                768:{
                    margin: 20
                },
                1200:{
                    navText: ['<i class="icon icon-arrow_prew"></i>', '<i class="icon icon-arrow_next"></i>'],
                    dots: false,
                    nav: true,
                }
            }
        });

        //Certifications popup
        let $popupCertification = $('.certification_carousel_popup');
        $popupCertification.owlCarousel({
            loop: false,
            margin: 5,
            items:1,
            dots: true,
            nav: false,
            //autoWidth:true,
            responsive:{
                768:{
                    margin: 10
                },
                1200:{
                    navText: ['<i class="icon icon-arrow_prew"></i>', '<i class="icon icon-arrow_next"></i>'],
                    dots: false,
                    nav: true,
                    margin: 20,
                    autoWidth:false,
                    items:1,
                }
            }
        });

        //Open popup & go to slide
        $certifications.find('.fade-popup').bind('click.awards.popup', function () {
            $popupCertification.trigger('to.owl.carousel', $(this).attr('data-id'));
        });



        //Reviews
        let $reviewsCarousel = $('.reviews_carousel'),
            heightVisible = 120;

        $reviewsCarousel.on('initialized.owl.carousel', function(){
            //Read more for reviews
            $reviewsCarousel.find('.review_item_wrap').each(function () {
                let $commentWrap = $(this).find('.comment');
                if($commentWrap.height() > heightVisible) {
                    $commentWrap.attr('data-f-h', $commentWrap.height());
                    $commentWrap.css('height', heightVisible);
                    $commentWrap.siblings('.read-more').show();
                } else {
                    $commentWrap.siblings('.read-more').hide();
                }
            });
        });

        $reviewsCarousel.on('changed.owl.carousel', function(){
            $reviewsCarousel.find('.review_item_wrap').each(function () {
                if($(this).find('button.hide').length) {
                    $(this).find('.comment').animate({
                        'height': heightVisible
                    }, 300);
                    $(this).find('button.hide').removeClass('hide');
                }
            })
        });


        $reviewsCarousel.owlCarousel({
            loop: false,
            margin: 5,
            items:1,
            dots: true,
            nav: false,
            autoWidth:true,
            responsive:{
                768:{
                    margin: 10
                },
                1200:{
                    navText: ['<i class="icon icon-arrow_prew"></i>', '<i class="icon icon-arrow_next"></i>'],
                    dots: false,
                    nav: true,
                    margin: 20,
                    autoWidth:false,
                    items:2,
                }
            }
        });

        //Show|Hide more comment
        $reviewsCarousel.find('.review_item_wrap').on('click', '.read-more button', function () {
            let $comment = $(this).closest('.content').find('.comment'),
                setHeight = 0;

            if($(this).hasClass('hide')) {
                setHeight = heightVisible;
            } else {
                setHeight = $comment.attr('data-f-h');
            }

            $(this).toggleClass('hide');
            $comment.animate({
                'height': setHeight
            }, 300);
        });


    }
}